import { createContentPropTypes } from '../../../helpers/content';

const content = {
	cancelledSchedulePaymentSuccessHeader: "Your One-off payment's been cancelled",
	cancelledBacsSuccessHeader: "Your Bacs payment's been cancelled",
	cancelledDDSuccessHeader: "Your Direct Debit's been cancelled",
	cancelledSOSuccessHeader: 'Your standing order’s been cancelled',
	cancelledIftSuccessHeader: 'International Payment Cancelled',
	cancelledCHAPSSuccessHeader: 'CHAPS payment cancelled',
	cancelledIftSuccessBody: 'This payment won’t be submitted for processing and no money will leave this account.',
	cancelledCHAPSSuccessBody: 'This payment won’t be submitted for processing and no money will leave this account.',
	cancelledSuccessBody: 'It may be tomorrow (or the next working day) before your changes appear.',
	cancelledOkButton: 'OK',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
